import { useEffect } from 'react';
import { Events, tracking } from '@lib';
import { Question, QuestionType } from '@qmd-types/intakeForms';
import { BodyMeasurementForm } from './BodyMeasurementForm';
import { ConditionForm } from './ConditionForm';
import { EmailForm } from './EmailForm';
import { OptionForm } from './OptionForm';
import { StatementForm } from './StatementForm';
import { TextboxForm } from './TextboxForm';
import { useIntakeForm } from '../../context/useIntakeForm';
import { PharmacySelectionForm } from './PharmacySelectionForm';

type Props = {
  question: Question | null;
};

export function IntakeFormQuestion({ question }: Props): JSX.Element | null {
  const { currentQuestion, editQuestion } = useIntakeForm();
  const q = question || currentQuestion;

  useEffect(() => {
    if (!q) {
      return;
    }

    if (!editQuestion) {
      tracking.trackEvent(Events.VIEW_INTAKE_FORM_QUESTION, {
        QuestionText: q.question,
        QuestionType: q.type,
      });
    }
  }, [editQuestion, q]);

  if (!q) {
    return null;
  }

  switch (q.type) {
    case QuestionType.BODY_MEASUREMENT:
      return <BodyMeasurementForm key={q.intakeFormQuestionId} question={q} />;
    case QuestionType.CONDITION:
      return <ConditionForm key={q.intakeFormQuestionId} question={q} />;
    case QuestionType.EMAIL:
      return <EmailForm key={q.intakeFormQuestionId} question={q} />;
    case QuestionType.OPTION:
      return <OptionForm key={q.intakeFormQuestionId} question={q} />;
    case QuestionType.STATEMENT:
      return <StatementForm key={q.intakeFormQuestionId} question={q} />;
    case QuestionType.TEXTBOX:
      return <TextboxForm key={q.intakeFormQuestionId} question={q} />;
    case QuestionType.PHARMACY_SELECTION:
      return (
        <PharmacySelectionForm key={q.intakeFormQuestionId} question={q} />
      );
    default:
      return <div>Unknown question type</div>;
  }
}
